import EmptyState from 'components/EmptyState/EmptyState';
import { type FC } from 'react';
import type { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';

interface IMEIProps extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const IMEIRenderer: FC<IMEIProps> = ({ value }): CustomCellRendererReturn =>
  value.imei ? <div>{value.imei}</div> : <EmptyState text="Not available" />;

export default IMEIRenderer;
